export const hexToRgba = (hex: string, opacity: number) => {
  // Remove the leading '#' if present
  hex = hex.replace(/^#/, "");

  // Determine the length of the hex string
  let r,
    g,
    b,
    a = 1;

  if (hex.length === 3) {
    // Short hex format: #RGB
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else if (hex.length === 4) {
    // Short hex format with alpha: #RGBA
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
    a = parseInt(hex[3] + hex[3], 16) / 255;
  } else if (hex.length === 6) {
    // Standard hex format: #RRGGBB
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  } else if (hex.length === 8) {
    // Standard hex format with alpha: #RRGGBBAA
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
    a = parseInt(hex.substring(6, 8), 16) / 255;
  } else {
    throw new Error("Invalid hex color format");
  }

  // If an opacity value is provided, use it to override the alpha channel
  if (opacity !== undefined) {
    a = opacity;
  }

  // Return the rgba string
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};
